exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".avatarForGroup:hover .el-image__inner {\n  -webkit-transform: scale(1.1) !important;\n          transform: scale(1.1) !important;\n}\n.avatarForGroup .el-image__inner {\n  -webkit-transform: scale(1);\n          transform: scale(1);\n  -webkit-transition: -webkit-transform 0.3s;\n  transition: -webkit-transform 0.3s;\n  transition: transform 0.3s;\n  transition: transform 0.3s, -webkit-transform 0.3s;\n}\n", ""]);

// exports
